<template>
	<span class="activity-text">
		<template v-for="(part, i) in parts" :key="i">
			<Mention
				v-if="part.type === 'mention'"
				:userId="part.userId"
				:user="part.user"
				:isMe="part.isMe"
			/>
			<span v-else-if="part.text" v-text="part.text" />
		</template>
	</span>
</template>

<script>
import { parseMessageParts } from '@/components/Message/utils'
import Mention from '@/components/Message/Mention'

export default {
	name: 'ActivityText',

	components: { Mention },

	props: {
		message: { type: Object, required: true },
	},

	computed: {
		parts() {
			return parseMessageParts(this.message)
		},
	},
}
</script>
